import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import Container from '@mui/material/Container'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Grid from '@mui/material/Grid2'
import Stack from '@mui/material/Stack'
import Modal from '@mui/material/Modal'
import { flushSync } from 'react-dom'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import {
  deleteData,
  updateData,
  getData,
  addRequestsData,
  upsertDataTournaments,
} from '../api/indexedDBHandler'

import TeamDrawCardZona from './Team/TeamDrawCardZona'

import TeamRegistrationCard from './Team/TeamRegistrationCard'
import TeamDrawCardComQ from './Team/TeamDrawCardComQ'
import TeamDrawCardCom from './Team/TeamDrawCardCom'
import TeamDrawCard from './Team/TeamDrawCard'
import { getLogoUrl } from '../api/Logo'
import { useNavigate } from 'react-router-dom'
const TournamentDraw = () => {
  const { id } = useParams()
  const [loading, setLoading] = useState(false)
  const [teams, setTeams] = useState([])
  const [tournament, setTournament] = useState([])
  const [teamsDraw, setTeamsDraw] = useState([])
  const [communication, setCommunication] = useState([])

  const [statusTournament, setStatusTournament] = useState('')
  const [disableBtDraw, setDisableBtDraw] = useState(true)
  const [disableBtFinishDraw, setDisableBtFinishDraw] = useState(true)
  const [disableBtCommunication, setDisableBtCommunication] = useState(true)
  const [textBtCommunication, setTexttCommunication] = useState('')
  const [commandName, setCommandName] = useState([])

  const [teamsNotLocation, setTeamsNotLocation] = useState(0)
  const [typeDraw, setTypeDraww] = useState(null)

  const [communicationModalOpen, setCommunicationModalOpen] = useState(false)
  const [selectedTeamForCommunication, setSelectedTeamForCommunication] =
    useState(null)
  const navigate = useNavigate()
  const url_back = '/tournaments/' + id
  const disTextDraw = {
    'Парные соревнования':
      'Жеребьёвка: сначала проведите жеребьёвку очереди (проставьте номер очереди у каждой команды и нажмите «Сохранить»), затем определите номер сектора. Заполненный протокол жеребьёвки находится в разделе «Документация»',
    'Парно - командные соревнования':
      'Жеребьёвка: сначала соедините пары в команды (при необходимости напишите названия команд), потом проведите жеребьёвку очереди (проставьте номер очереди у каждой команды и нажмите «Сохранить»), затем определите номер сектора. Заполненный протокол жеребьёвки находится в разделе «Документация»',
    'Командные соревнования':
      'Жеребьёвка: сначала соедините пары в команды (при необходимости напишите названия команд), потом проведите жеребьёвку очереди (проставьте номер очереди у каждой команды и нажмите «Сохранить»), затем определите номер сектора. Заполненный протокол жеребьёвки находится в разделе «Документация»',
  }
  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    color: theme.palette.text.secondary,
    ...theme.applyStyles('dark', {
      backgroundColor: '#1A2027',
    }),
  }))
  Object.size = function (obj) {
    var size = 0,
      key
    for (key in obj) {
      if (obj.hasOwnProperty(key)) size++
    }
    return size
  }
  useEffect(() => {
    setLoading(true)
    const getTournamentTeams = async () => {
      const resultsU = await getData('teams', 'id', id)
      if (resultsU.length > 0) {
        const { key, value } = resultsU[0]

        const teamsArray = Object.values(value)
        const filteredTeams = teamsArray.filter((teamEntry) => {
          const isValidTeam =
            teamEntry !== null &&
            typeof teamEntry === 'object' &&
            teamEntry.team?.status === 'Заявка одобрена'

          if (statusTournament === 'Жеребьёвка') {
            return isValidTeam && teamEntry.team?.status_location === 1
          } else return isValidTeam && teamEntry.team?.status_location != 2
        })
        setTeams(filteredTeams)

        const filteredFinisfDraw = teamsArray.filter(
          (e) =>
            typeof e === 'object' &&
            e !== null &&
            e.team.status == 'Заявка одобрена' &&
            e.team?.status_location === 1 &&
            e.team?.sector === null
        )
        if (filteredFinisfDraw.length === 0) {
          setDisableBtFinishDraw(false)
        }
        if (statusTournament === 'Взвешивание') {
          setDisableBtFinishDraw(true)
        }

        const sortdTeams = teamsArray
          .filter(
            (e) =>
              typeof e === 'object' &&
              e !== null &&
              e.team.status == 'Заявка одобрена' &&
              e.team?.status_location === 1
          )
          .sort((a, b) => {
            const queueA = Number(a.team.queue) || Infinity
            const queueB = Number(b.team.queue) || Infinity

            return queueA - queueB
          })
        console.log('sortdTeams 125', sortdTeams)

        setTeamsDraw(sortdTeams)
      }

      const resultsT = await getData('tournaments', 'id', id)
      if (resultsT.length > 0) {
        const { key, value } = resultsT[0]

        setTournament(value)
        setTypeDraww(value.tournament_draw)

        setStatusTournament(value.status_cup)
      }

      const resultsC = await getData('communication', 'id', id)
      if (resultsC.length > 0) {
        const { key, value } = resultsC[0]

        flushSync(() => {
          console.log('communication 147')
          setCommandName(value)
          setCommunication(value.communication)
        })
      }
      setLoading(false)
    }
    getTournamentTeams()
  }, [id])

  // useEffect(() => {
  //   const getCommunication = async () => {
  //     const resultsC = await getData('communication', 'id', id)
  //     if (resultsC.length > 0) {
  //       const { key, value } = resultsC[0]
  //       flushSync(() => {
  //         console.log('communication 164')
  //         setCommandName(value)
  //         setCommunication(value.communication)
  //       })
  //     }
  //   }
  //   getCommunication()
  // }, [communicationModalOpen])

  useEffect(() => {
    const checkGroupsValidity = () => {
      // 1. Собираем все ID из связок
      const allLinkedIds = communication ? communication.flat() : []
      // 2. Находим несвязанные команды
      const unlinkedTeams = teams.filter(
        (team) => !allLinkedIds.includes(team.team.id)
      ).length
      console.log('not SET communication 165', communication)
      const groupSizes = communication
        ? communication.map((group) => group.length)
        : []
      const uniqueSizes = [...new Set(groupSizes)]

      if (!communication) {
        setTexttCommunication('Нужно создать все команды')
        return true
      }
      if (communication.length === 0) {
        setTexttCommunication('Нужно создать все команды')
        return true
      }
      if (
        uniqueSizes.length !== 1 ||
        !(uniqueSizes[0] === 2 || uniqueSizes[0] === 3)
      ) {
        setTexttCommunication('Все команды должны содержать 2 или 3 пары')

        return true
      }

      const currentSize = uniqueSizes[0]

      if (currentSize === 2 && unlinkedTeams > 1) {
        setTexttCommunication(
          'При командах по 2 пары можно иметь только 1 несвязанную пару'
        )
        return true
      }

      if (currentSize === 3 && unlinkedTeams > 2) {
        setTexttCommunication(
          'При командах по 3 пары можно иметь максимум 2 несвязанных пар'
        )

        return true
      }

      const totalTeams = teams.length
      const linkedTeamsCount = allLinkedIds.length
      const remaining = totalTeams - linkedTeamsCount - unlinkedTeams

      if (remaining !== 0) {
        setTexttCommunication('Есть неучтенные пары')
        return true
      }
      setTexttCommunication('')
      return false
    }

    const canComplete = checkGroupsValidity()
    setDisableBtCommunication(canComplete)
  }, [communication, teams])

  useEffect(() => {
    const updateCommunication = async () => {
      console.log('not SET communication 223', communication)
      const update_data = {
        communication: communication,
        id: id,
      }

      await updateData('communication', id, {
        ...update_data,
      })
    }
    if (communication && communication.length > 0) updateCommunication()
  }, [communication])

  useEffect(() => {
    if (teams.length == 0) return

    const filteredTeams = teams.filter(
      (e) => typeof e === 'object' && e !== null && !e.team?.status_location
    )

    setTeamsNotLocation(filteredTeams.length)
  }, [teams])
  useEffect(() => {
    if (teamsNotLocation === 0) {
      setDisableBtDraw(false)
    } else setDisableBtDraw(true)
  }, [teamsNotLocation])

  const buttonOpenDrawCom = async () => {
    //  setLoading(true)
    let value
    let cc
    let arrName = {}
    const resultsU = await getData('teams', 'id', id)
    if (resultsU.length > 0) {
      value = resultsU[0].value

      const resultsC = await getData('communication', 'id', id)
      if (resultsC.length > 0) {
        // const { key, value } = resultsC[0]

        flushSync(() => {
          console.log('communication 262')
          setCommandName(resultsC[0].value)
          setCommunication(resultsC[0].value.communication)
        })

        const resultsU = await getData('teams', 'id', id)
        if (resultsU.length > 0) {
          const teamsArray = Object.values(resultsU[0].value)
          console.log(
            'teamsArrayteamsArrateamsArrayteamsArrayteamsArrayy',
            teamsArray
          )
          const sortdTeams = teamsArray
            .filter(
              (e) =>
                typeof e === 'object' &&
                e !== null &&
                e.team.status == 'Заявка одобрена' &&
                e.team?.status_location === 1
            )
            .sort((a, b) => {
              const queueA = Number(a.team.queue) || Infinity
              const queueB = Number(b.team.queue) || Infinity

              return queueA - queueB
            })

          setTeamsDraw(sortdTeams)

          console.log('teamsDraw', teamsDraw)
          console.log('sortdTeams', sortdTeams)
        }

        console.log('value 1', value)
        console.log('commandName 1', commandName)
        console.log('arrName 1', arrName)
        console.log('communication', communication)
        cc = resultsC[0].value.communication
        console.log('teams0', teams[0])
        resultsC[0].value.communication.forEach((teams) => {
          let communication1 = null
          let communication2 = null
          console.log('teams[0]', teams[0])
          console.log(
            'resultsC[0].value?.[teams[0]]',
            resultsC[0].value?.[teams[0]]
          )
          if (teams[0]) {
            if (resultsC[0].value[teams[0]])
              arrName[teams[0]] = resultsC[0].value?.[teams[0]]
            else if (value[teams[0]].team?.comand_name)
              arrName[teams[0]] = value[teams[0]].team?.comand_name
            communication1 = teams[1] ? teams[1] : null
            communication2 = teams[2] ? teams[2] : null
            if (value[teams[0]].team) {
              value[teams[0]].team.communication_team1 = teams[1]
                ? teams[1]
                : null
              value[teams[0]].team.communication_team2 = teams[2]
                ? teams[2]
                : null
              value[teams[0]].team.comand_name = resultsC[0].value?.[teams[0]]
                ? resultsC[0].value?.[teams[0]]
                : null
            }
          }
          if (teams[1]) {
            if (resultsC[0].value[teams[1]])
              arrName[teams[1]] = resultsC[0].value?.[teams[1]]
            else if (value[teams[1]].team?.comand_name)
              arrName[teams[1]] = value[teams[1]].team?.comand_name
            communication1 = teams[0] ? teams[0] : null
            communication2 = teams[2] ? teams[2] : null
            if (value[teams[1]].team) {
              value[teams[1]].team.communication_team1 = teams[0]
                ? teams[0]
                : null
              value[teams[1]].team.communication_team2 = teams[2]
                ? teams[2]
                : null
              value[teams[1]].team.comand_name = resultsC[0].value?.[teams[1]]
                ? resultsC[0].value?.[teams[1]]
                : null
            }
          }
          if (teams[2]) {
            if (resultsC[0].value[teams[2]])
              arrName[teams[2]] = resultsC[0].value?.[teams[2]]
            else if (value[teams[2]].team?.comand_name)
              arrName[teams[2]] = value[teams[2]].team?.comand_name
            communication1 = teams[0] ? teams[0] : null
            communication2 = teams[1] ? teams[1] : null
            if (value[teams[2]].team) {
              value[teams[2]].team.communication_team1 = teams[0]
                ? teams[0]
                : null
              value[teams[2]].team.communication_team2 = teams[1]
                ? teams[1]
                : null
              value[teams[2]].team.comand_name = resultsC[0].value?.[teams[2]]
                ? resultsC[0].value?.[teams[2]]
                : null
            }
          }
        })
      }
    }
    console.log('value', value)
    console.log('commandName 2', commandName)
    console.log('arrName 2 ммм', arrName)
    console.log(
      'communication stringify',
      JSON.stringify(cc ? cc : communication)
    )
    console.log('arrName stringify', JSON.stringify(arrName))
    if (value) {
      await updateData('teams', id, {
        ...value,
      })
    }
    // обновить статус туррира до жеребьевки
    console.log('not SET communication 351', communication)
    const update_data_server = {
      status_cup: 'Жеребьёвка',
      communication: JSON.stringify(cc ? cc : communication),
      command_name: JSON.stringify(arrName),
      id: id,
      requestKey: `${id}_updateComTournament_${new Date().getTime()}`,
    }
    console.log('update_data_server 2', update_data_server)
    //const requestKey = `${e.id}_dellUser_${new Date().getTime()}`

    try {
      await addRequestsData('requests', {
        url: 'tournaments/updateComTournament.php',
        ...update_data_server,
      })
    } catch (error) {}

    const update_data = {
      status_cup: 'Жеребьёвка',
    }
    await updateData('tournaments', id, {
      ...update_data,
    })
    setLoading(false)
    setStatusTournament('Жеребьёвка')
  }

  const buttonOpenDraw = async (e = 'Жеребьёвка') => {
    setLoading(true)
    console.log('e ', e)
    setStatusTournament(e)

    const update_data = {
      status_cup: e,
    }
    console.log('buttonOpenDraw 4', update_data)
    await updateData('tournaments', id, {
      ...update_data,
    })
    console.log('buttonOpenDraw 5')
    setLoading(false)
    console.log('buttonOpenDraw 6')
    try {
      //   const requestKey = `${e.id}_dellUser_${new Date().getTime()}`
      //  requestKey:  `${e.id}_dellUser_${new Date().getTime()}`,
      const requestKey = `${id}_statusCup_${new Date().getTime()}`
      await addRequestsData('requests', {
        url: 'tournaments/statusCup.php',
        ...update_data,
        id: id,
        requestKey,
      })
    } catch (error) {}
  }
  const isDisabledButton = () => {}
  const teamLocation = async (e, d) => {
    try {
      const resultsU = await getData('teams', 'id', id)

      if (resultsU.length === 0) {
        console.error('Турнир не найден')
        return
      }

      //const tournamentData = resultsU[0].value
      const tournamentData = Object.values(resultsU[0].value)

      const updatedTeams = tournamentData.map((teamEntry) => {
        if (
          typeof teamEntry === 'object' && // Проверяем, что e это объект
          (teamEntry !== null && teamEntry.team.id) === e
        ) {
          // Обновляем только нужную команду
          return {
            ...teamEntry,
            team: {
              ...teamEntry.team,
              status_location: d,
            },
          }
        }
        return teamEntry
      })
      var notLocation = 0
      var obj = {}
      for (let teams of updatedTeams) {
        if (typeof teams === 'object' && teams !== null) {
          obj[teams.team.id] = teams
          if (
            teams.team.status === 'Заявка одобрена' &&
            teams.team.status_location === null
          ) {
            notLocation++
          }
        } else obj['id'] = teams
      }
      setTeamsNotLocation(notLocation)
      deleteData('teams', id)
      upsertDataTournaments('teams', obj)

      const teamsArray = Object.values(obj)
      const filteredTeams = teamsArray.filter(
        (e) =>
          typeof e === 'object' &&
          e !== null &&
          e.team.status == 'Заявка одобрена'
      )

      setTeams(filteredTeams)
      // const teamsArray = Object.values(obj)
      // setTeams(teamsArray)
      const update_data = {
        idt: id,
        locatoon: d,
        team: e,
        requestKey: `${id}_locationTeam_${new Date().getTime()}`,
      }
      //   const requestKey = `${id}_dellUser_${new Date().getTime()}`
      //  requestKey:  `${id}_dellUser_${new Date().getTime()}`,
      try {
        await addRequestsData('requests', {
          url: 'teams/locationTeam.php',
          ...update_data,
        })
      } catch (error) {}
    } catch (error) {
      console.error('Ошибка при обновлении статуса:', error)
    }
  }

  const responseMeme = async (name, idteam, code = null) => {
    //setCommandName
  }

  const responseCommunication = async (e, idteam, code = null) => {
    if (code === 'openModalCommunication') {
      setSelectedTeamForCommunication(idteam)
      setCommunicationModalOpen(true)
    }
    if (code === 'openModalCommunicationGroup') {
      setSelectedTeamForCommunication(idteam)
      setCommunicationModalOpen(true)
    }

    if (code === 'delComunications') {
      handleRemoveId(idteam)
    }
  }

  const handleRemoveId = (idToRemove) => {
    console.log('not SET communication 504', communication)
    const asCommunication = communication
      .map((group) => {
        if (Array.isArray(group)) {
          const filtered = group.filter((id) => id !== idToRemove)

          if (filtered.length <= 1) return null
          return filtered
        }

        if (group === idToRemove) return null
        return group
      })
      .filter((group) => {
        if (group === null) return false
        if (Array.isArray(group) && group.length < 2) return false
        return true
      })
    console.log('communication 519')
    setCommunication(asCommunication)

    if (asCommunication.length === 0) {
      const awC = async () => {
        console.log('not SET communication 527', communication)
        const update_data = {
          communication: asCommunication,
          id: id,
        }

        await updateData('communication', id, {
          ...update_data,
        })
      }
      awC()
    }
  }
  // Фильтрация свободных команд (не входящих ни в одну группу)
  const getAvailableTeams = () => {
    console.log('not SET communication 542', communication)
    const allUsedIds = communication ? communication.flat() : []
    return teams.filter(
      (team) =>
        !allUsedIds.includes(team.team.id) &&
        team.team.id !== selectedTeamForCommunication
    )
  }
  const name = (teamData) => {
    if (tournament.competition_type == 'Рейтинговое соревнование')
      return teamData?.team_name_ru
    return teamData?.preferred_name == 'en'
      ? teamData?.team_name_en
        ? teamData?.team_name_en
        : teamData?.team_name_ru
      : teamData?.team_name_ru
  }
  // Модальное окно для выбора команды
  const CommunicationModal = () => (
    <Modal
      open={communicationModalOpen}
      onClose={() => setCommunicationModalOpen(false)}
    >
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 400,
          bgcolor: 'background.paper',
          boxShadow: 24,
          p: 4,
          maxHeight: '80vh',
          overflowY: 'auto',
        }}
      >
        <Typography variant="h6" gutterBottom>
          Выберите команду для связки
        </Typography>

        {getAvailableTeams().map((team) => (
          <Paper
            key={team.team.id}
            sx={{
              p: 2,
              mb: 2,
              cursor: 'pointer',
              '&:hover': { bgcolor: 'action.hover' },
            }}
            onClick={() => {
              setCommunication((prev) => {
                const search =
                  typeof selectedTeamForCommunication === 'object'
                    ? selectedTeamForCommunication[0]
                    : selectedTeamForCommunication
                const relatedGroups = prev.filter((group) =>
                  group.includes(search)
                )

                const newGroup =
                  typeof selectedTeamForCommunication === 'object'
                    ? [
                        ...new Set([
                          ...relatedGroups.flat(),
                          ...selectedTeamForCommunication.flat(),
                          team.team.id,
                        ]),
                      ]
                    : [
                        ...new Set([
                          ...relatedGroups.flat(),
                          selectedTeamForCommunication,
                          team.team.id,
                        ]),
                      ]

                if (newGroup.length > 3) {
                  alert('Максимум 3 команды в группе!')
                  return prev
                }

                return [
                  ...prev.filter((group) => !relatedGroups.includes(group)),
                  newGroup, //
                ]
              })
              setCommunicationModalOpen(false)
            }}

            // onClick={() => {
            //   setCommunication((prev) => [
            //     ...prev,
            //     [selectedTeamForCommunication, team.team.id],
            //   ])
            //   setCommunicationModalOpen(false)
            // }}
          >
            <Typography variant="subtitle1">{name(team.team)}</Typography>
            {team.athlete.map((athlete, index) => (
              <Typography key={index} variant="body2" style={{ color: 'gray' }}>
                {athlete.fio}
              </Typography>
            ))}
          </Paper>
        ))}
      </Box>
    </Modal>
  )

  const responseDrawCom = async (e, idteam, code = null) => {
    if (code && code === 'Queue') teamQueue(idteam, e)
    if (code && code === 'addSectorQ') {
      teamSector(idteam.teamId, idteam.sector, idteam.zona)
    }
  }
  const responseDraw = async (e, idteam, code = null) => {
    console.log('code', code)
    console.log('e', e)
    console.log('idteam', idteam)
    if (code && code === 'delQueue') teamQueue(idteam, e)
    else if (code && code === 'step') {
      //teamQueue(idteam, e)
      teamSector(idteam, e.sector, e.color)
    } else teamSector(idteam, e)
  }
  const teamSector = async (e, d, zona = null) => {
    try {
      const resultsU = await getData('teams', 'id', id)

      if (resultsU.length === 0) {
        console.error('Турнир не найден')
        return
      }

      const tournamentData = Object.values(resultsU[0].value)

      if (d && e) {
        const isDuplicate = tournamentData.some(
          (teamEntry) => Number(teamEntry?.team?.sector) === Number(d)
        )

        if (isDuplicate) {
          alert(`Номер сектора ${d} уже занят другой командой!`)
          return
        }
      }

      const updatedTeams = tournamentData.map((teamEntry) => {
        if (
          typeof teamEntry === 'object' &&
          (teamEntry !== null && teamEntry.team.id) === e
        ) {
          return {
            ...teamEntry,
            team: {
              ...teamEntry.team,
              sector: d,
              zona: zona,
            },
          }
        }
        return teamEntry
      })
      var obj = {}
      for (let teams of updatedTeams) {
        if (typeof teams === 'object' && teams !== null) {
          obj[teams.team.id] = teams
        } else obj['id'] = teams
      }
      deleteData('teams', id)
      upsertDataTournaments('teams', obj)
      const teamsArray = Object.values(obj)
      const filteredTeams = teamsArray.filter(
        (e) =>
          typeof e === 'object' &&
          e !== null &&
          e.team.status == 'Заявка одобрена' &&
          e.team?.status_location === 1
      )
      setTeams(filteredTeams)
      const sortdTeams = teamsArray
        .filter(
          (e) =>
            typeof e === 'object' &&
            e !== null &&
            e.team.status == 'Заявка одобрена' &&
            e.team?.status_location === 1
        )
        .sort((a, b) => {
          const queueA = Number(a.team.queue) || Infinity
          const queueB = Number(b.team.queue) || Infinity

          return queueA - queueB
        })

      const filteredFinisfDraw = teamsArray.filter(
        (e) =>
          typeof e === 'object' &&
          e !== null &&
          e.team.status == 'Заявка одобрена' &&
          e.team?.status_location === 1 &&
          e.team?.sector === null
      )

      if (filteredFinisfDraw.length === 0) {
        setDisableBtFinishDraw(false)
      }
      console.log('sortdTeams 687', sortdTeams)

      setTeamsDraw(sortdTeams)

      const update_data = {
        idt: id,
        sector: d,
        team: e,
        zona: zona,
        requestKey: `${id}_sectorTeam_${new Date().getTime()}`,
      }
      //   const requestKey = `${id}_dellUser_${new Date().getTime()}`
      //  requestKey:  `${id}_dellUser_${new Date().getTime()}`,
      try {
        await addRequestsData('requests', {
          url: 'draw/sectorTeam.php',
          ...update_data,
        })
      } catch (error) {}
    } catch (error) {
      console.error('Ошибка при обновлении статуса:', error)
    }
  }
  const responseQueue = async (e, idteam, code = null) => {
    teamQueue(idteam, e)
  }
  const finishDraw = () => {
    // eslint-disable-next-line no-restricted-globals
    const result = confirm(
      'Проверьте все данные. Изменить очередь и сектор после начала турнира будет невозможно.'
    )
    if (result) {
      setDisableBtFinishDraw(true)
      buttonOpenDraw('Активен')

      navigate(url_back)
      // teamIsLocation(teamData.id)
      // setbackgroundColor('#BADBAD33')
    }
  }

  const teamQueue = async (e, d) => {
    try {
      const resultsU = await getData('teams', 'id', id)

      if (resultsU.length === 0) {
        console.error('Турнир не найден')
        return
      }

      const tournamentData = Object.values(resultsU[0].value)
      if (d && e) {
        const isDuplicate = tournamentData.some(
          (teamEntry) => Number(teamEntry?.team?.queue) === Number(d)
        )

        if (isDuplicate) {
          alert(`Номер очереди ${d} уже занят другой командой!`)
          return
        }
      }

      const updatedTeams = tournamentData.map((teamEntry) => {
        if (teamEntry && typeof teamEntry === 'object' && teamEntry.team?.id) {
          const shouldUpdate = Array.isArray(e)
            ? e.includes(teamEntry.team.id)
            : teamEntry.team.id === e

          if (shouldUpdate) {
            return {
              ...teamEntry,
              team: {
                ...teamEntry.team,
                queue: d,
              },
            }
          }
        }

        return teamEntry
      })
      var obj = {}

      for (let teams of updatedTeams) {
        if (typeof teams === 'object' && teams !== null) {
          obj[teams.team.id] = teams
        } else obj['id'] = teams
      }
      deleteData('teams', id)
      upsertDataTournaments('teams', obj)

      const teamsArray = Object.values(obj)
      const filteredTeams = teamsArray.filter(
        (e) =>
          typeof e === 'object' &&
          e !== null &&
          e.team.status == 'Заявка одобрена' &&
          e.team?.status_location === 1
      )

      setTeams(filteredTeams)
      const sortdTeams = teamsArray
        .filter(
          (e) =>
            typeof e === 'object' &&
            e !== null &&
            e.team.status == 'Заявка одобрена' &&
            e.team?.status_location === 1
        )
        .sort((a, b) => {
          const queueA = Number(a.team.queue) || Infinity
          const queueB = Number(b.team.queue) || Infinity

          return queueA - queueB
        })
      console.log('sortdTeams 798', sortdTeams)
      setTeamsDraw(sortdTeams)

      const update_data = {
        idt: id,
        queue: d,
        team: e,
        requestKey: `${id}_queueTeam_${new Date().getTime()}`,
      }
      //   const requestKey = `${id}_dellUser_${new Date().getTime()}`
      //  requestKey:  `${id}_dellUser_${new Date().getTime()}`,
      try {
        await addRequestsData('requests', {
          url: 'draw/queueTeam.php',
          ...update_data,
        })
      } catch (error) {}
    } catch (error) {
      console.error('Ошибка при обновлении статуса:', error)
    }
  }
  const sortTeams = (e) => {}
  const teamNotLocation = async (e) => {
    teamLocation(e, 2)
  }
  const teamIsLocation = async (e) => {
    teamLocation(e, 1)
  }
  const isAccessible = () => {
    if (tournament.competition_format === 'Парные соревнования') {
      if (statusTournament === 'Создан' || statusTournament === 'Регистрация') {
        if (teams?.length > 0) return true
      }
    } else {
      if (statusTournament === 'Создан' || statusTournament === 'Регистрация') {
        if (teams?.length > 0) {
          if (disableBtDraw != false) return true
        }
      }
    }
    // (&&
    //         ) ||
    //         ((statusTournament === 'Создан' ||
    //           statusTournament === 'Регистрация') &&
    //           teams?.length > 0 &&
    //           disableBtDraw != false &&
    //
    return false
  }
  if (tournament && teams)
    return (
      <Container sx={{ mb: 15 }}>
        <div role="presentation" style={{ textAlign: 'left', width: '100%' }}>
          <Breadcrumbs maxItems={2} aria-label="breadcrumb">
            <Link underline="hover" color="inherit" href="/tournaments-list">
              Турниры
            </Link>
            <Link underline="hover" color="inherit" href={url_back}>
              Редактирование
            </Link>
            <Typography sx={{ color: 'text.primary' }}>Жеребьёвка</Typography>
          </Breadcrumbs>
        </div>
        <Box sx={{ flexGrow: 1, mt: 2 }}>
          <Grid container spacing={2}>
            <Grid size={{ xs: 12, md: 12 }}>
              <Item>
                <Stack spacing={1} direction="row">
                  <div>
                    {tournament.logocup && (
                      <img
                        alt="Logo Team"
                        variant="square"
                        src={getLogoUrl(tournament.logocup)}
                        style={{
                          objectFit: 'contain !important',
                          height: '60px',
                        }}
                      />
                    )}
                  </div>
                  <div>
                    <Stack spacing={0}>
                      <Typography
                        variant="h6"
                        gutterBottom
                        color="black"
                        style={{ lineHeight: 'normal', marginBottom: 0 }}
                      >
                        {tournament.tournament_name}
                      </Typography>
                      <Typography
                        variant="body2"
                        gutterBottom
                        color="black"
                        style={{ lineHeight: 'normal', marginBottom: 0 }}
                      >
                        Водоём: {tournament.water_body}
                      </Typography>
                      <Typography
                        variant="body2"
                        gutterBottom
                        color="black"
                        style={{ lineHeight: 'normal' }}
                      >
                        Дата: {tournament.start_date} - {tournament.end_date}
                      </Typography>
                    </Stack>
                  </div>
                </Stack>
                <Typography
                  variant="body2"
                  gutterBottom
                  color="black"
                  style={{ lineHeight: 'normal' }}
                >
                  Количество команд: {Object.size(teams)}
                </Typography>
                <Typography
                  variant="body2"
                  gutterBottom
                  style={{ lineHeight: 'normal', marginBottom: 0 }}
                >
                  Статус: {statusTournament}
                </Typography>
                <Typography
                  variant="body2"
                  gutterBottom
                  style={{ lineHeight: 'normal', marginBottom: 0 }}
                >
                  Формат: {tournament.competition_format}
                </Typography>
                {/* <Typography
                  variant="body2"
                  gutterBottom
                  style={{ lineHeight: 'normal', marginBottom: 0 }}
                >
                  Жеребьёвка: {tournament.tournament_draw}
                </Typography> */}
                {(statusTournament === 'Создан' ||
                  statusTournament === 'Регистрация') &&
                  tournament.competition_format === 'Парные соревнования' && (
                    <>
                      <Box mt={1} display="flex" justifyContent="flex-end">
                        <Button
                          variant="contained"
                          color="success"
                          onClick={(e) => buttonOpenDraw('Жеребьёвка')}
                          disabled={disableBtDraw}
                          startIcon={loading && <CircularProgress size={20} />}
                        >
                          {loading ? 'Загрузка...' : 'Открыть жеребьёвку  '}
                        </Button>
                      </Box>
                      <Typography
                        variant="body2"
                        gutterBottom
                        style={{ lineHeight: 'normal', marginBottom: 0 }}
                      >
                        Подтвердите присутствие всех команд и их состав.
                      </Typography>
                    </>
                  )}
                {(statusTournament === 'Создан' ||
                  statusTournament === 'Регистрация') &&
                  tournament.competition_format ===
                    'Парные соревнования (по зонам)' && (
                    <>
                      <Box mt={1} display="flex" justifyContent="flex-end">
                        <Button
                          variant="contained"
                          color="success"
                          onClick={(e) => buttonOpenDraw('Жеребьёвка')}
                          disabled={disableBtDraw}
                          startIcon={loading && <CircularProgress size={20} />}
                        >
                          {loading ? 'Загрузка...' : 'Открыть жеребьёвку  '}
                        </Button>
                      </Box>
                      <Typography
                        variant="body2"
                        gutterBottom
                        style={{ lineHeight: 'normal', marginBottom: 0 }}
                      >
                        Подтвердите присутствие всех команд и их состав.
                      </Typography>
                    </>
                  )}
                {(statusTournament === 'Создан' ||
                  statusTournament === 'Регистрация') &&
                  tournament.competition_format != 'Парные соревнования' &&
                  disableBtDraw != false && (
                    <>
                      <Typography
                        variant="body2"
                        gutterBottom
                        style={{
                          lineHeight: 'normal',
                          marginBottom: 0,
                          marginTop: '15px',
                          color: 'red',
                        }}
                      >
                        Подтвердите присутствие всех команд и их состав.
                      </Typography>
                    </>
                  )}

                {(statusTournament === 'Создан' ||
                  statusTournament === 'Регистрация') &&
                  tournament.competition_format != 'Парные соревнования' &&
                  tournament.competition_format !=
                    'Парные соревнования (по зонам)' &&
                  disableBtDraw != true && (
                    <>
                      <Box mt={1} display="flex" justifyContent="flex-end">
                        <Button
                          variant="contained"
                          color="success"
                          onClick={(e) => buttonOpenDrawCom()}
                          disabled={disableBtCommunication}
                          startIcon={loading && <CircularProgress size={20} />}
                        >
                          {loading ? 'Загрузка...' : 'Открыть жеребьёвку'}
                        </Button>
                      </Box>
                      <Typography
                        variant="body2"
                        gutterBottom
                        style={{
                          lineHeight: 'normal',
                          marginBottom: 0,
                          color: 'red',
                        }}
                      >
                        {textBtCommunication}
                      </Typography>
                    </>
                  )}
                {statusTournament === 'Жеребьёвка' && (
                  <Box mt={1} display="flex" justifyContent="flex-end">
                    <Button
                      onClick={finishDraw}
                      disabled={disableBtFinishDraw}
                      variant="contained"
                      color="success"
                      size="small"
                    >
                      Завершить жеребьевку
                    </Button>
                  </Box>
                )}
                {/* 
                <Box mt={1} display="flex" justifyContent="flex-end">
                  <Button size="small">
                    Скачать пустой шаблон бланка жеребьевки
                  </Button>
                </Box> */}
              </Item>
            </Grid>
          </Grid>
        </Box>
        <Grid
          container
          spacing={2}
          style={{ width: '100%', paddingTop: '10px' }}
        >
          {isAccessible() &&
            teams.map((item, index) => (
              <TeamRegistrationCard
                tournament={tournament}
                key={item.team.id}
                teamDataTemp={item.team}
                athleteDataTemp={item.athlete}
                teamIsLocation={teamIsLocation}
                teamNotLocation={teamNotLocation}
              />
            ))}
        </Grid>
        <Grid
          container
          spacing={2}
          style={{ width: '100%', paddingTop: '10px' }}
        >
          {statusTournament === 'Жеребьёвка' && (
            <>{disTextDraw[tournament.competition_format]}</>
          )}
          {/* Блок для одиночных команд (не входящих в communication)   || ((statusTournament === 'Создан' ||
            statusTournament === 'Регистрация') && (disableBtDraw != true &&
            tournament.competition_format != 'Парные соревнования' ) ) ) */}

          {(statusTournament === 'Создан' ||
            statusTournament === 'Регистрация') &&
            disableBtDraw != true &&
            tournament.competition_format != 'Парные соревнования' &&
            tournament.competition_format != 'Парные соревнования (по зонам)' &&
            teams?.length > 0 &&
            teams.map((item) => {
              console.log('not SET communication 1137', communication)
              const isInCommunication = (communication || []).some((group) =>
                group.includes(item.team.id)
              )
              return (
                item.team.status_location === 1 &&
                tournament.competition_format !== 'Парные соревнования' &&
                tournament.competition_format !=
                  'Парные соревнования (по зонам)' &&
                !item.team.communication_team1 &&
                !item.team.communication_team2 &&
                !isInCommunication && (
                  <TeamDrawCardCom
                    tournament={tournament}
                    key={item.team.id}
                    teamDataTemp={item.team}
                    athleteDataTemp={item.athlete}
                    typeDraw={typeDraw}
                    ids={item.team.id}
                    typeCard="Сommunication_null"
                    response={responseCommunication}
                    responseMeme={responseMeme}
                  />
                )
              )
            })}
          {/* Блок для групповых команд из communication */}
          {(statusTournament === 'Создан' ||
            statusTournament === 'Регистрация') &&
            disableBtDraw !== true &&
            tournament.competition_format !== 'Парные соревнования' &&
            tournament.competition_format != 'Парные соревнования (по зонам)' &&
            teams?.length > 0 &&
            (communication || []).map((group, groupIndex) => {
              console.log('not SET communication 1168', communication)
              const groupTeams = teams.filter((item) =>
                group.includes(item.team.id)
              )

              if (groupTeams.length === 0) return null

              const groupKey = [...group].sort((a, b) => a - b).join('-')

              return (
                <TeamDrawCardCom
                  tournament={tournament}
                  key={`group-${groupKey}`}
                  teamDataTemp={groupTeams.map((t) => t.team)}
                  athleteDataTemp={groupTeams}
                  typeDraw={typeDraw}
                  ids={group}
                  typeCard="GroupCommunication"
                  response={responseCommunication}
                  groupIndex={groupIndex}
                  responseMeme={responseMeme}
                />
              )
            })}
          {statusTournament === 'Жеребьёвка' &&
            teamsDraw?.length > 0 &&
            tournament.competition_format !== 'Парные соревнования' &&
            tournament.competition_format != 'Парные соревнования (по зонам)' &&
            (() => {
              console.log('not SET communication 1196', communication)
              console.log('teamsDraw 1196', teamsDraw)
              // Создаем единый массив групп и одиночных команд
              const allGroupedIds = communication?.flat() || []

              const combinedTeams = [
                // Группированные команды
                ...(communication?.map((group) =>
                  group
                    .map((id) => teamsDraw.find((t) => t.team.id === id))
                    .filter(Boolean)
                ) || []),

                ...teamsDraw
                  .filter((team) => !allGroupedIds.includes(team.team.id))
                  .map((team) => [team]),
              ]
              return combinedTeams.map((teamGroup, index) => {
                if (teamGroup.length > 1 && !teamGroup[0].team.queue) {
                  // && !teamGroup[0].queue
                  const groupIds = teamGroup.map((t) => t.team.id)
                  console.log('TeamDrawCardComQ 1233', teamGroup)
                  return (
                    <TeamDrawCardComQ
                      tournament={tournament}
                      key={`group-${groupIds.join('-')}`}
                      teamDataTemp={teamGroup.map((t) => t.team)}
                      athleteDataTemp={teamGroup}
                      typeDraw={typeDraw}
                      ids={groupIds}
                      typeCard="group"
                      response={responseDrawCom}
                      groupIndex={index}
                      responseMeme={responseMeme}
                    />
                  )
                }

                // Для одиночных команд

                const team = teamGroup[0]
                if (!teamGroup[0].team.queue)
                  console.log('TeamDrawCardComQ 1251', team)
                if (!teamGroup[0].team.queue)
                  return (
                    <TeamDrawCardComQ
                      tournament={tournament}
                      key={`single-${team.team.id}`}
                      teamDataTemp={team.team}
                      athleteDataTemp={team}
                      typeDraw={typeDraw}
                      ids={[team.team.id]}
                      typeCard="single"
                      response={responseDrawCom}
                      responseMeme={responseMeme}
                    />
                  )
              })
            })()}

          {statusTournament === 'Жеребьёвка' &&
            teamsDraw?.length > 0 &&
            tournament.competition_format !== 'Парные соревнования' &&
            tournament.competition_format != 'Парные соревнования (по зонам)' &&
            (() => {
              console.log('not SET communication 1256', communication)
              // Создаем единый массив групп и одиночных команд
              const allGroupedIds = communication?.flat() || []
              const combinedTeams = [
                // Группированные команды
                ...(communication?.map((group) =>
                  group
                    .map((id) => teamsDraw.find((t) => t.team.id === id))
                    .filter(Boolean)
                ) || []),

                // Оставшиеся одиночные команды
                ...teamsDraw
                  .filter((team) => !allGroupedIds.includes(team.team.id))
                  .map((team) => [team]),
              ].sort(
                (a, b) =>
                  (a[0]?.team.queue || Infinity) -
                  (b[0]?.team.queue || Infinity)
              )

              return combinedTeams.map((teamGroup, index) => {
                if (teamGroup.length > 1 && teamGroup[0].team.queue) {
                  // && !teamGroup[0].queue
                  console.log('TeamDrawCardComQ 1297', teamGroup)
                  const groupIds = teamGroup.map((t) => t.team.id)
                  return (
                    <TeamDrawCardComQ
                      tournament={tournament}
                      key={`group-${groupIds.join('-')}`}
                      teamDataTemp={teamGroup.map((t) => t.team)}
                      athleteDataTemp={teamGroup}
                      typeDraw={typeDraw}
                      ids={groupIds}
                      typeCard="group"
                      response={responseDrawCom}
                      groupIndex={index}
                      responseMeme={responseMeme}
                    />
                  )
                }

                // Для одиночных команд
                const team = teamGroup[0]
                if (teamGroup[0].team.queue)
                  console.log('TeamDrawCardComQ 1318', team)

                if (teamGroup[0].team.queue)
                  return (
                    <TeamDrawCardComQ
                      tournament={tournament}
                      key={`single-${team.team.id}`}
                      teamDataTemp={team.team}
                      athleteDataTemp={team}
                      typeDraw={typeDraw}
                      ids={[team.team.id]}
                      typeCard="single"
                      response={responseDrawCom}
                      responseMeme={responseMeme}
                    />
                  )
              })
            })()}
        </Grid>

        <Grid
          container
          spacing={2}
          style={{ width: '100%', paddingTop: '10px' }}
        >
          {statusTournament === 'Жеребьёвка' &&
            teamsDraw?.length > 0 &&
            teamsDraw.map(
              (item, index) =>
                tournament.competition_format ===
                  'Парные соревнования (по зонам)' &&
                !item.team.queue &&
                !item.team.sector && (
                  <TeamDrawCard
                    tournament={tournament}
                    key={item.team.id}
                    teamDataTemp={item.team}
                    athleteDataTemp={item.athlete}
                    typeDraw={typeDraw}
                    ids={item.team.id}
                    typeCard="Rega"
                    response={responseDraw}
                  />
                )
            )}
        </Grid>

        <Grid
          container
          spacing={2}
          style={{ width: '100%', paddingTop: '10px' }}
        >
          {statusTournament === 'Жеребьёвка' &&
            teamsDraw?.length > 0 &&
            teamsDraw.map(
              (item, index) =>
                tournament.competition_format === 'Парные соревнования' &&
                !item.team.queue &&
                !item.team.sector && (
                  <TeamDrawCard
                    tournament={tournament}
                    key={item.team.id}
                    teamDataTemp={item.team}
                    athleteDataTemp={item.athlete}
                    typeDraw={typeDraw}
                    ids={item.team.id}
                    typeCard="Rega"
                    response={responseDraw}
                  />
                )
            )}
        </Grid>
        {/* Парные соревнования (по зонам) */}
        <Grid
          container
          spacing={2}
          style={{ width: '100%', paddingTop: '10px' }}
        >
          {statusTournament === 'Жеребьёвка' &&
            teamsDraw?.length > 0 &&
            teamsDraw.map(
              (item, index) =>
                tournament.competition_format ===
                  'Парные соревнования (по зонам)' &&
                item.team.queue &&
                !item.team.sector && (
                  <TeamDrawCardZona
                    tournament={tournament}
                    key={item.team.id}
                    teamDataTemp={item.team}
                    athleteDataTemp={item.athlete}
                    typeDraw={typeDraw}
                    ids={item.team.id}
                    typeCard="Draw"
                    response={responseDraw}
                  />
                )
            )}
        </Grid>
        <Grid
          container
          spacing={2}
          style={{ width: '100%', paddingTop: '10px' }}
        >
          {statusTournament === 'Жеребьёвка' &&
            teamsDraw?.length > 0 &&
            teamsDraw.map(
              (item, index) =>
                tournament.competition_format === 'Парные соревнования' &&
                item.team.queue &&
                !item.team.sector && (
                  <TeamDrawCard
                    tournament={tournament}
                    key={item.team.id}
                    teamDataTemp={item.team}
                    athleteDataTemp={item.athlete}
                    typeDraw={typeDraw}
                    ids={item.team.id}
                    typeCard="Draw"
                    response={responseDraw}
                  />
                )
            )}
        </Grid>
        <Grid
          container
          spacing={2}
          style={{ width: '100%', paddingTop: '10px' }}
        >
          {statusTournament === 'Жеребьёвка' &&
            teamsDraw?.length > 0 &&
            teamsDraw.map(
              (item, index) =>
                tournament.competition_format === 'Парные соревнования' &&
                item.team.queue &&
                !item.team.sector && (
                  <TeamDrawCard
                    tournament={tournament}
                    key={item.team.id}
                    teamDataTemp={item.team}
                    athleteDataTemp={item.athlete}
                    typeDraw={typeDraw}
                    ids={item.team.id}
                    typeCard="Draw"
                    response={responseDraw}
                  />
                )
            )}
        </Grid>
        <Grid
          container
          spacing={2}
          style={{ width: '100%', paddingTop: '10px' }}
        >
          {statusTournament === 'Жеребьёвка' &&
            teamsDraw?.length > 0 &&
            teamsDraw.map(
              (item, index) =>
                tournament.competition_format ===
                  'Парные соревнования (по зонам)' &&
                item.team.queue &&
                item.team.sector && (
                  <TeamDrawCardZona
                    tournament={tournament}
                    key={item.team.id}
                    teamDataTemp={item.team}
                    athleteDataTemp={item.athlete}
                    typeDraw={typeDraw}
                    ids={item.team.id}
                    typeCard="Sector"
                    response={responseDraw}
                  />
                )
            )}
        </Grid>
        <Grid
          container
          spacing={2}
          style={{ width: '100%', paddingTop: '10px' }}
        >
          {statusTournament === 'Жеребьёвка' &&
            teamsDraw?.length > 0 &&
            teamsDraw.map(
              (item, index) =>
                tournament.competition_format === 'Парные соревнования' &&
                item.team.queue &&
                item.team.sector && (
                  <TeamDrawCard
                    tournament={tournament}
                    key={item.team.id}
                    teamDataTemp={item.team}
                    athleteDataTemp={item.athlete}
                    typeDraw={typeDraw}
                    ids={item.team.id}
                    typeCard="Sector"
                    response={responseDraw}
                  />
                )
            )}
        </Grid>
        {/* <Typography
          variant="subtitle2"
          gutterBottom
          color="black"
          sx={{ mt: 0 }}
        >
          Водоём: {tournament.status_cup}
        </Typography> */}
        <CommunicationModal />
      </Container>
    )
}
export default TournamentDraw
